<template>
  <div>
    <h4 class="text-center">Pesquisar modelos de não conformidade</h4>

    <img
      src="@/assets/images/search.png"
      alt="search"
      class="d-none d-lg-block w-100 mb-5"
    />

    <div class="form-group row mb-1">
      <div class="col-lg-3 mb-1 mb-lg-0">
        <label>Id</label>
        <input
          type="text"
          class="form-control"
          v-model="noncompliance_model_filters.id"
        />
      </div>
      <div class="col-lg-9 mb-1 mb-lg-0">
        <label>Natureza do risco</label>
        <input
          type="text"
          class="form-control"
          v-model="noncompliance_model_filters.nature_of_risk"
        />
      </div>
    </div>

    <div class="form-group">
      <label>Categoria</label>
      <input
        type="text"
        class="form-control"
        v-model="noncompliance_model_filters.category"
      />
    </div>

    <div class="form-group">
      <label>Item da norma</label>
      <input
        type="text"
        class="form-control"
        v-model="noncompliance_model_filters.standard_item"
      />
    </div>

    <div class="form-group">
      <label>Descrição</label>
      <input
        type="text"
        class="form-control"
        v-model="noncompliance_model_filters.noncompliance_model_description"
      />
    </div>

    <div
      class="
        d-flex
        flex-column flex-lg-row
        align-items-center
        Isjustify-content-start
        justify-content-lg-between
      "
    >
      <button class="btn btn-success mb-3 mb-lg-0" @click="onFilter">
        <font-awesome-icon :icon="['fas', 'filter']"></font-awesome-icon>
        Filtrar
      </button>

      <button class="btn btn-secondary" @click="clearFilter">
        <font-awesome-icon :icon="['fas', 'broom']"></font-awesome-icon>
        Resetar
      </button>
    </div>
  </div>
</template>

<script>
  import { onBeforeMount, onMounted, ref } from 'vue'
  import useNoncomplianceModel from '@/modules/NoncomplianceModel.js'

  export default {
    setup() {
      const loading = ref(true)

      const { noncompliance_model_filters, listNoncomplianceModels } =
        useNoncomplianceModel()

      const refreshList = () => {
        listNoncomplianceModels(1, 10)
      }

      const clearFilter = () => {
        noncompliance_model_filters.value = {}
        refreshList()
      }

      const onFilter = () => {
        refreshList()
      }

      onBeforeMount(() => {
        clearFilter()
      })

      onMounted(() => {})

      return {
        noncompliance_model_filters,
        onFilter,
        clearFilter,
        loading,
      }
    },
  }
</script>
